import MlbLineupConverter from './MlbLineupConverter.js';
import MlbSessionConverter from './MlbSessionConverter.js';
import MlbPlaysConverter from './MlbPlaysConverter.js';

class MlbGameFeedConverter {
    constructor(playsConverter, sessionConverter, lineupConverter) {
        if (typeof(lineupConverter) !== 'undefined' && !(lineupConverter instanceof MlbLineupConverter)) {
            throw new TypeError('lineupConverter must be undefined (to use default implementation) or MlbLineupConverter\'s class instance');
        }
        if (typeof(sessionConverter) !== 'undefined' && !(sessionConverter instanceof MlbSessionConverter)) {
            throw new TypeError('sessionConverter must be undefined (to use default implementation) or MlbSessionConverter\'s class instance');
        }
        if (typeof(playsConverter) !== 'undefined' && !(playsConverter instanceof MlbPlaysConverter)) {
            throw new TypeError('playsConverter must be undefined (to use default implementation) or MlbPlaysConverter\'s class instance');
        }

        this.lineupConverter = lineupConverter || new MlbLineupConverter();
        this.sessionConverter = sessionConverter || new MlbSessionConverter();
        this.playsConverter = playsConverter || new MlbPlaysConverter();
    }

    convert(game) {
        // TODO - entity
        if (!game || typeof(game) !== 'object') {
            throw new TypeError('game must be an object');
        }

        const session = this.sessionConverter.convert(game);
        const lineups = this.lineupConverter.convertLineups(
            game, session.id
        );

        session.lineups.push(...lineups);

        // convert plays
        if (game.liveData && game.liveData.plays && game.liveData.plays.allPlays) {
            this.playsConverter.reset();
            for (let p = 0; p < game.liveData.plays.allPlays.length; p++) {
                const play = game.liveData.plays.allPlays[p];
                session.results.push(
                    ...this.playsConverter.convert(play, session.id)
                );
            }
        }

        return session;
    }
}

export default MlbGameFeedConverter;